import { StatusEnum } from "@project-management-system/shared-models";
import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";

@Entity('orders')
export class PVHOrdersEntity {
    @PrimaryGeneratedColumn('increment', {
        name: "id",
    })
    id: number;

    @Column("varchar", {
        name: "po_number",
    })
    poNumber: string

    @Column("varchar", {
        name: "currency",
    })
    currency: string

    @Column("varchar", {
        name: "buyer_name",
    })
    buyerName: string

    @Column("varchar", {
        name: "buyer_save_name",
    })
    buyerSaveName: string


    // @Column("varchar", {
    //     name: "external_ref",
    // })
    // externalRef: string

    @Column('text', {
        name: "delivery_address"
    })
    deliveryAddress: string

    @Column('text', {
        name: "buyer_address"
    })
    buyerAddress: string


    @Column("varchar", {
        name: "total_quantity",
    })
    totalQuantity: string

    @Column("varchar", {
        name: "division",
    })
    division: string

     @Column("varchar", {
        name: "order_value",
    })
    orderValue: string


    /* poline */

    @Column("varchar", {
        name: "po_line",
    })
    poLine: string

    @Column("varchar", {
        name: "incoterm",
    })
    incoterm: string

    @Column("varchar", {
        name: "short_description",
    })
    shortDescription: string

    @Column("varchar", {
        name: "gender",
    })
    gender: string

    @Column('varchar', {
        name: "delivery_date"
    })
    deliveryDate: string

    @Column("varchar", {
        name: "ex_factory_date",
    })
    exFactoryDate: string

    @Column("varchar", {
        name: "trans_mode",
    })
    transMode: string

    @Column("varchar", {
        name: "port",
    })
    portOfLoading: string



    /* sizes */


    @Column("varchar", {
        name: "line",
    })
    line: string

    @Column("varchar", {
        name: "plm_style",
    })
    plmStyle: string

    @Column("varchar", {
        name: "size",
    })
    size: string

    @Column("varchar", {
        name: "dimensions",
    })
    dimensions: string

    @Column("varchar", {
        name: "size_description",
    })
    sizeDescription: string

    @Column("varchar", {
        name: "color",
    })
    color: string

    @Column("varchar", {
        name: "upc",
    })
    upc: string

    @Column("varchar", {
        name: "unit_price",
    })
    unitPrice: string

    @Column("varchar", {
        name: "quantity",
    })
    quantity: string



    @Column({
        type: 'enum',
        enum: StatusEnum,
        name: 'status',
    })
    status: StatusEnum;

    @CreateDateColumn({
        name: "created_at",
    })
    createdAt: string;

    @Column("varchar", {
        nullable: true,
        name: "created_user",
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: "updated_at",
    })
    updatedAt: string;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag",
    })
    versionFlag: number;

    @Column({
        nullable: false,
        name: "is_active",
        default: 1
    })
    isActive: boolean;




}